import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
// Note: React Router v7 warnings are informational; no change needed for v6 runtime.
import { HelmetProvider } from 'react-helmet-async';
import { AuthProvider } from './contexts/AuthContext.tsx';
import { FirebaseAuthProvider } from './contexts/FirebaseAuthContext.tsx';

import App from './App.tsx';
import './styles/index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AuthProvider>
      <FirebaseAuthProvider>
        <HelmetProvider>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </HelmetProvider>
      </FirebaseAuthProvider>
    </AuthProvider>
  </React.StrictMode>
);
